export enum TimelineActivityType {
  None = 0,
  Email = 1,
  Meeting = 2,
  CallSummary = 3,
  Note = 4,
  Custom = 5,
}
